import { Box, Typography } from '@mui/material';
import { useMemo } from 'react';
import { sanitizeText } from 'utils/sanitizeText';
import theme from 'theme/theme';

const CustomHeadline = ({
  text,
  customInfoHeadline,
}: {
  customInfoHeadline: string;
  text: string;
}) => {
  const santinizedText = useMemo(() => sanitizeText(text), [text]);

  return (
    <Box
      className='main-style'
      data-testid='landing-item'
      sx={{ backgroundColor: theme.palette.background.paper }}>
      <Box className='limit-width'>
        <Typography variant='h2' textAlign='center' marginTop='42px'>
          {customInfoHeadline}
        </Typography>
        <Typography
          variant='body1'
          className='text-area'
          dangerouslySetInnerHTML={{
            __html: santinizedText,
          }}
        />
      </Box>
    </Box>
  );
};

export default CustomHeadline;
